/*
 * @Author: xuguangyao 943060174@qq.com
 * @Date: 2024-07-30 18:21:07
 * @LastEditors: xuguangyao 943060174@qq.com
 * @LastEditTime: 2024-08-28 15:28:04
 * @FilePath: \mp-union\src\store\User\User.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cache from '@/utils/cache.js'
const User = {
    state: {
        openId: '',
        user: null,
        customerId:'',
    },

    mutations: {
        SET_USER(state, data){
            state.user = data
        },
        SET_OPEN_ID(state, data){
            state.openId = data
        },
        SET_USER_OUTLOGIN(state) {
            console.log(Cache,'s222')
            Cache.removeItem('personUser');
            Cache.removeItem('companyUser');
            Cache.removeItem('currentLoginType');
            Cache.removeItem('accessToken');
            Cache.removeItem('refreshToken');
            Cache.removeItem('personToken');
            Cache.removeItem('companyToken');
            Cache.removeItem('userLogo');
            state.user = ''
        }
    },

    actions: {
        userOutLogin( { commit} ) {
            return new Promise((resolve) => {
                commit('SET_USER_OUTLOGIN')
                resolve()
            })
        },
        setUser({ commit }, data) {
            commit('SET_USER', data)
        }
    },

    getters: {
        userInfo: state => state.userInfo,
        openId: state => state.openId,
        user: state => state.user,
    }
}

export default User;

